import { Component, Input } from '@angular/core';

@Component({
  selector: 'csv-help',
  template: require('./csvhelp.component.html'),
})
export class CsvHelpComponent {
  infoTab = 1;
  @Input() tracker: any;

  constructor() {}

  get fieldsArray() {
    return Object.keys(this.tracker.fields).map(key => ({
      ...this.tracker.fields[key],
      fieldName: key
    }));
  }

  fieldNotes(ef: any): string {
    const ft = ef.fieldType;

    if ([1, 2, 3, 5, 7].includes(ft)) {
      return "Alias or value from the allowed list";
    }

    if ([4, 6].includes(ft)) {
      return "Free-entry text";
    }

    if (ft == 8) {
      return "Any release alias or name. See Releases in this project.";
    }

    if (ft == 9) {
      return "Any valid date, or empty";
    }

    if (ft == 10) {
      return "Any number, or empty";
    }

    if (ft == 12) {
      return "Any username from the members list";
    }

    return ""; // Return empty string if fieldType does not match any condition
  }
}
